import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";
import { MediaType } from "../enum.js";
import { overlayTextsSchema } from "../overlay-text.js";

export const createStorySchema = z.object({
	group_id: z.string(),
	media_url: z.string(),
	media_type: z.enum([MediaType.IMAGE, MediaType.VIDEO]),
	caption: z.string().max(500).optional(),
	overlay_texts: overlayTextsSchema,
	duration: z.number().int().min(1).max(60).optional(),
	zoom: z.number().min(0.25).max(4).optional(),
	rotation: z.number().optional(),
	background_color: z.string().nullable().optional(),
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
});

export type CreateStoryPayload = z.infer<typeof createStorySchema>;
